import { focusTrap } from "../utility/focusTrap"

export default function init() {
	const html = document.documentElement
	const body = document.querySelector('body')
	const button = document.querySelector('.js-site-mobile-nav-toggle')
	const mobileNav = document.querySelector('.site-mobile-nav')
	const mobileClose = document.querySelector('.column-nav__close')
	const bg = document.querySelector('.site-mobile-nav-background')
	const trapFocus = focusTrap(button, mobileNav)
	
	let isOpen = false

	function open() {	
	    isOpen = true
	    button.classList.add('open')
	    animateIn(mobileNav)
	    animateIn(bg)
	    html.style.overflow = 'hidden'
		body.classList.add('overflow-fixed')
	    trapFocus.enter()
	}

	function close() {
	    isOpen = false
	    button.classList.remove('open')
	    animateOut(mobileNav)
	    animateOut(bg)
	    html.style.overflow = ''
		body.classList.remove('overflow-fixed')
	    trapFocus.exit()
	}

	function toggle() {
		isOpen ? close() : open()
	}

	function onKeydown(event) {
		const escKey = (event.key === 'Escape' || event.keyCode === 27)
		if (escKey && isOpen) close()
	}

	// setup events
	bg.addEventListener('click', close)
	mobileClose.addEventListener('click', close)
	button.addEventListener('click', toggle)
	window.addEventListener('keydown', onKeydown)
}


function animateIn(el, callback) {
	el.classList.add('state')
	setTimeout(() => {
		el.classList.add('open') 
		callback && callback()
	}, 200)
}

function animateOut(el, callback) {
	el.classList.remove('open')
	setTimeout(() => {
		el.classList.remove('state')
		callback && callback()
	}, 500)
}

